import { render, staticRenderFns } from "./planosAnuais.vue?vue&type=template&id=1636d0ec"
import script from "./planosAnuais.vue?vue&type=script&lang=js"
export * from "./planosAnuais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports